/**
 * Authentication API
 * 
 * Handles user authentication with backend.
 */

import { baseURL } from './index';

export { getAuthHeaders } from './authHeaders';

/**
 * Login with Firebase token and get session token
 */
export const loginWithFirebase = async (firebaseToken) => {
  const response = await fetch(`${baseURL}/api/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ firebase_token: firebaseToken }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Login failed');
  }

  return response.json();
};
/**
 * Verify session token
 */
export const verifySession = async (sessionToken) => {
  const response = await fetch(`${baseURL}/api/auth/verify`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ session_token: sessionToken }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Session verification failed');
  }

  return response.json();
};

/**
 * Logout and invalidate session
 */
export const logoutSession = async (sessionToken) => {
  const response = await fetch(`${baseURL}/api/auth/logout`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ session_token: sessionToken }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Logout failed');
  }

  return response.json();
};

export const authorizeBrowserClient = async (sessionToken, authorizationRequest) => {
  const response = await fetch(`${baseURL}/api/browser/oauth/authorize`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Session-Token': sessionToken,
    },
    body: JSON.stringify(authorizationRequest),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Extension authorization failed');
  }

  return response.json();
};
